"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayIntersect = void 0;
function arrayIntersect(arr1, arr2) {
    return arr1.filter(function (item) { return arr2.includes(item); });
}
exports.arrayIntersect = arrayIntersect;
